import React from "react";
import { Stack, Tooltip, Typography } from "@mui/material";
import { MdsIcon } from "@sinch/components";

export const IconStat: React.FC<{ icon: React.ElementType; value: string | number; title: string }> = ({
  icon,
  value,
  title,
}) => (
  <Tooltip enterTouchDelay={0} placement="top" title={title}>
    <Stack
      direction="row"
      spacing={0.5}
      sx={{
        alignItems: "center",
      }}
    >
      <MdsIcon fontSize="xs" icon={icon} sx={{ color: ({ palette }) => palette.grey["800"] }} />
      <Typography
        sx={{
          color: ({ palette }) => palette.grey["800"],
          lineHeight: 1,
        }}
        variant="descriptionSmallBold"
      >
        {value}
      </Typography>
    </Stack>
  </Tooltip>
);
